"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const muiSwitch = {
    styleOverrides: {
        switchBase: {
            margin: 0,
            width: 'unset',
            height: 'unset',
        },
    },
};
exports.default = muiSwitch;
//# sourceMappingURL=muiSwitch.js.map